type GoogleAddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

export type GooglePlace = {
  address_components?: GoogleAddressComponent[];
  formatted_address?: string;
  geometry?: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
  place_id?: string;
};

/**
 * Converts a Google Places result into an EasyTech address.
 * Street number and route are collected separately so house numbers
 * are never lost regardless of component order.
 */
export function parseGooglePlace(
  place: GooglePlace,
  displayLabel = ""
): EasyTech.Address | undefined {
  if (!place.geometry?.location || !place.address_components?.length) {
    return undefined;
  }

  let streetNumber = "";
  let route = "";
  let addressCompl = "";
  let zipCode = "";
  let city = "";
  let country = "";

  for (const comp of place.address_components) {
    const val = comp.long_name;

    if (comp.types.includes("street_number")) {
      streetNumber = val;
    } else if (comp.types.includes("route")) {
      route = val;
    } else if (comp.types.includes("subpremise")) {
      addressCompl = val;
    } else if (comp.types.includes("locality") || comp.types.includes("postal_town")) {
      city = val;
    } else if (comp.types.includes("postal_code")) {
      zipCode = val;
    } else if (comp.types.includes("country")) {
      country = val;
    }
  }

  return {
    displayLabel: displayLabel || place.formatted_address || "",
    address: [streetNumber, route].filter(Boolean).join(" ").trim(),
    addressCompl,
    zipCode,
    city,
    country,
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
    placeId: place.place_id,
  };
}
